import { AppointmentFlowLaneCard } from "./AppointmentFlowLaneCard";
import { AppointmentFlowActionOperations, AppointmentFlowSteps } from "../Enums";
import { makeObservable, observable } from "mobx";


export interface IFlowLaneDetails {
    timeInLane: string,
    actions: Array<IAppointmentFlowLaneAction>
}
export interface IAppointmentFlowCompletedLaneDetails extends IFlowLaneDetails {
    title: string
}
export interface IAppointmentFlowLaneDetails extends IFlowLaneDetails {
    title: AppointmentFlowSteps
}

export interface IAppointmentFlowLaneAction {
    status: AppointmentFlowSteps,
    operation: AppointmentFlowActionOperations,
    requiresConfirm: boolean,
    cardLoading?: number
}

export interface ISelectedFlowCard {
    card?: AppointmentFlowLaneCard
    laneIndex: number
    cardIndex: number
    actionIndex: number
    futureStatus?: AppointmentFlowSteps
    operation?: AppointmentFlowActionOperations
}

export class AppointmentFlowLaneDetails implements IAppointmentFlowLaneDetails {
    title: AppointmentFlowSteps;
    timeInLane: string;
    actions: Array<AppointmentFlowLaneAction>;

    constructor(params: Partial<IAppointmentFlowLaneDetails>) {
        const {
            title = AppointmentFlowSteps.Scheduled,
            timeInLane = "",
            actions = []
        } = params;
        this.title = title;
        this.timeInLane = timeInLane;
        this.actions = actions;
    }
}
export class AppointmentFlowCompletedLaneDetails implements IAppointmentFlowCompletedLaneDetails {
    title: string;
    timeInLane: string;
    actions: Array<AppointmentFlowLaneAction>;

    constructor(params: Partial<IAppointmentFlowCompletedLaneDetails>) {
        const {
            title = "",
            timeInLane = "",
            actions = []
        } = params;
        this.title = title;
        this.timeInLane = timeInLane;
        this.actions = actions;
    }
}

export class AppointmentFlowLaneAction implements IAppointmentFlowLaneAction {
    status: AppointmentFlowSteps;
    operation: AppointmentFlowActionOperations;
    requiresConfirm: boolean;
    cardLoading?: number;

    constructor(params: Partial<IAppointmentFlowLaneAction>) {
        const {
            status = AppointmentFlowSteps.Scheduled,
            operation = AppointmentFlowActionOperations.CheckIn,
            requiresConfirm = false
        } = params;
        this.status = status;
        this.operation = operation;
        this.requiresConfirm = requiresConfirm;
    }
}

export class SelectedFlowCard implements ISelectedFlowCard {
    @observable card?: AppointmentFlowLaneCard
    @observable laneIndex: number
    @observable cardIndex: number
    @observable actionIndex: number
    @observable futureStatus?: AppointmentFlowSteps
    @observable operation?: AppointmentFlowActionOperations

    constructor(params: Partial<ISelectedFlowCard>) {
        const {
            card = params.card && new AppointmentFlowLaneCard(params.card),
            laneIndex = 0,
            cardIndex = 0,
            actionIndex = 0,
            futureStatus = params.futureStatus,
            operation = params.operation
        } = params;

        this.card = card;
        this.laneIndex = laneIndex;
        this.cardIndex = cardIndex;
        this.actionIndex = actionIndex;
        this.futureStatus = futureStatus;
        this.operation = operation;

        makeObservable(this, undefined, { autoBind: true });
    }
}
